import { inject } from "@angular/core";
import { CanActivateFn, Router } from "@angular/router";
import { hasStoredSession } from "src/app/common/functions/storage.functions";

export const initGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  // Was previously a raw `sessionStorage.getItem("sessionData")` check —
  // duplicated (and out of sync with) the actual storage mechanism in
  // storage.functions.ts, which encrypts, can write to either session or
  // local storage depending on the caller, and validates a real token
  // rather than just checking that a key exists. hasStoredSession() is the
  // single source of truth everything else already uses (e.g.
  // auth.interceptor.ts's storage-wipe detection).
  if (hasStoredSession()) {
    return true;
  }

  return router.createUrlTree(["/login"]);

  // When guard returns false
  // Angular cancels navigation
  // BUT does NOT redirect anywhere
  // return false;
};
